import { render } from "./Postgraduate.vue?vue&type=template&id=dacd43f2&scoped=true&ts=true"
import script from "./Postgraduate.vue?vue&type=script&lang=ts"
export * from "./Postgraduate.vue?vue&type=script&lang=ts"

import "./Postgraduate.vue?vue&type=style&index=0&id=dacd43f2&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dacd43f2"]])

export default __exports__